
import { environment } from '@environment/environment';


export function forceHttps() {

  if (
    (environment.production && environment.env_file === "prod") ||
    (!environment.production && environment.env_file === "dev")
  ) {
    const isLocalhost = location.hostname === 'localhost';
    const isSecure = location.protocol === 'https:';

    if (!isSecure && !isLocalhost) {
      const httpsUrl = `https://${location.host}${location.pathname}${location.search}${location.hash}`;
      window.location.replace(httpsUrl);
    }
  }

}

export function authorize_claim(claims_hash: bigint, rights: string | string[]): boolean {
  //rights = key da claim, podendo ser um array de keys ou uma única key. Ex.: "user.allow.notify.email:1" ou ["user.allow.notify.email:1", "user.allow.notify.sms:2"]
  //a key é formada por segmentos separados por . e no final tem um segmento especial que é a propria value da claim, esse segmento é separado por ":"
  // exemplo: user.allow.notify.email:1 -> value = 1


  let ret: boolean = true;

  const claims: string[] = [];
  if (!Array.isArray(rights)) {
    claims.push(rights);
  }
  else {
    claims.push(...rights);
  }


  for (const right of claims) {

    const key = right.split(':')[0];
    const value = right.split(':')[1];

    if (!BigInt(value) || BigInt(value) < 0) {
      ret = false;
      continue;
    }

    const claimValue = 1n << BigInt(value);

    ret = ret && (!!(claimValue & claims_hash));
  }

  return ret;
}
